import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

export default function Login() {
  const [form, setForm] = useState({ email: "", password: "" });
  const [err, setErr] = useState(""); const [busy, setBusy] = useState(false);
  const { login, formatApiError } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();

  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setErr("");
    try {
      const u = await login(form.email, form.password);
      toast.success("Welcome back.");
      const dest = loc.state?.from?.pathname || (u.onboarded ? "/app" : "/onboarding");
      nav(dest);
    } catch (e) {
      const msg = formatApiError(e.response?.data?.detail) || e.message;
      setErr(msg); toast.error(msg);
    } finally { setBusy(false); }
  };

  return (
    <div className="max-w-md mx-auto px-6 md:px-12 py-16">
      <div className="label-eyebrow">Log In</div>
      <h1 className="wordmark mt-4 text-4xl md:text-5xl uppercase">Welcome back.</h1>
      <form onSubmit={submit} className="mt-8 bg-card border border-border rounded-lg p-8 space-y-4">
        <div>
          <label className="label-eyebrow">Email</label>
          <input required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
            className="mt-2 w-full rounded-md border border-input bg-background px-3 py-2.5 outline-none focus:ring-2 focus:ring-ring" data-testid="login-email" />
        </div>
        <div>
          <label className="label-eyebrow">Password</label>
          <input required type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })}
            className="mt-2 w-full rounded-md border border-input bg-background px-3 py-2.5 outline-none focus:ring-2 focus:ring-ring" data-testid="login-password" />
        </div>
        {err && <div className="text-sm text-destructive" data-testid="login-error">{err}</div>}
        <button disabled={busy} className="btn-primary w-full disabled:opacity-60" data-testid="login-submit">
          {busy ? "Signing in…" : "Sign In"}
        </button>
      </form>
      <p className="mt-6 text-sm text-muted-foreground">
        New here? <Link to="/join" className="text-primary underline">Join BA30</Link>
      </p>
    </div>
  );
}
